import { connect } from 'react-redux';
import NewCourse from '../components/NewCourse/index';

const mapStateToProps = ({ auth }) => ({ ...auth });

export default connect(mapStateToProps, null)(NewCourse);



// WEBPACK FOOTER //
// ./src/containers/NewCourse.js